export default __webpack_public_path__ + "static/media/sypialnie6.c13d68aa.jpg";